import { getScheduled } from "../repository/scheduled.repo";

export const GetScheduled = async () => {
  try {
    const resp = await getScheduled();
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
